import React from 'react';
import { Button } from './ui/button';
import { ShieldCheck } from 'lucide-react';

const DataPurgeDialog = ({ open, onAcknowledge, toolName }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" data-testid="data-purge-dialog">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 space-y-4 animate-in fade-in zoom-in-95 duration-200">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
            <ShieldCheck className="w-5 h-5 text-emerald-600" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Source Files Removed
          </h3>
        </div>
        <p className="text-sm text-slate-600 leading-relaxed">
          The {toolName} has completed successfully. All uploaded source files have been securely
          removed and are no longer stored on the server. Only the {toolName === 'comparison' ? 'comparison' : 'validation'} results
          have been retained for your records.
        </p>
        <Button
          onClick={onAcknowledge}
          className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
          data-testid="data-purge-acknowledge-btn"
        >
          Acknowledge
        </Button>
      </div>
    </div>
  );
};

export default DataPurgeDialog;
